<template>
  <b-modal header-class="ion-bg-modal-header" size="xl"
           centered scrollable no-close-on-backdrop
           v-model="visible">

    <template #modal-header>
      <div class="fw-bold">{{ $t('notice.noticeTitle') }}</div>
    </template>

    <div class="row" v-if="!$_utils.isEmpty(item)">
      <div class="col-xl-12">
        <div class="card shadow-none mb-0">
          <div class="card-body">

            <!-- Title Start -->
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-3">
                <div class="avatar-sm">
                  <div class="avatar-title bg-light text-primary rounded-circle font-size-18">
                    <i class="mdi mdi-information-outline"></i>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1 overflow-hidden mb-1">
                <h5 class="font-size-18 fw-bold">
                  <span class="badge rounded-pill me-2" :class="item.isPublish ? 'badge-soft-primary' : 'badge-soft-secondary'">
                    {{ item.isPublish ? $t('common.open') : $t('common.private') }}
                  </span>
                  <span class="badge rounded-pill me-2" :class="item.noticeType === 'General' ? 'badge-soft-success' : 'badge-soft-danger'">
                    {{ $_formatter.noticeTypeName(item.noticeType) }}
                  </span>
                  <span>{{ item.title }}</span>
                </h5>
                <div v-if="item.noticeType === 'Urgent'">
                  <span class="font-size-14 text-muted">{{ $t('notice.showPeriod') }} : </span>
                  <span class="text-danger ps-2">{{ item.noticeStart }} ~ {{ item.noticeEnd }}</span>
                </div>
                <div>
                  <span class="font-size-14 text-muted">{{ $t('notice.created') }} : {{ item.created }}</span>
                  <span class="text-primary ps-2 pe-2">|</span>
                  <span class="font-size-14 text-muted">{{ $t('notice.updated') }} : {{ item.updated }}</span>
                </div>
              </div>
            </div>
            <!-- Title End -->

            <hr />

            <!-- START Attache File -->
            <template v-if="!$_utils.isEmpty(item.attachFile)">
              <div class="row mb-3">
                <div class="col-xl-12 text-end">
                  <i class="mdi mdi-paperclip icon-padding-right text-muted" />
                  <span class="text-muted ct-padding-right-50">{{ $t('common.attachment') }} :</span>
                  <a :href="`/onmapi/view/File/download/${item.attachFile.fileId}`" download>
                    {{ item.attachFile.orgName }}
                  </a>
                </div>
              </div>
            </template>
            <!-- END Attache File -->

            <!-- Contents Start -->
            <div v-html="`${item.contents}`" style="overflow: auto; max-height: 600px; min-height: 200px" />
            <!-- Contents End -->

          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 text-end">
        <b-button variant="secondary" class="w-xs p-1" @click="close">{{ $t('btn.close') }}</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { http } from '@/auth-api';

export default {
  props: {
    selectedId: {
      type: Number
    }
  },
  data() {
    return {
      visible: false,
      item: null
    }
  },
  methods: {
    show() {
      const vm = this;

      vm.getItem();
      vm.visible = true;
    },
    getItem() {
      const vm = this;
      const _url = `/onmapi/view/Notice/retrieve/${this.selectedId}`;

      http.get(_url).then((res) => {
        vm.item = res.data.item;
      }).catch((err) => {
        console.error('Notice Retrieve Error !!', err)
      });
    },
    close() {
      const vm = this;

      vm.item = null;
      this.$emit('callback');
      vm.visible = false;
    }
  }
}
</script>
